export const DETAILS_FIELD_NAMES = [
  'Year of Release',
  'Release Year',
  'Rating',
  'Theatrical or Edited',
  'Length',
  'Length / Duration',
]

export const MEDIA_FIELD_NAMES = [
  'Poster',
  'Poster Image File Name (.jpg)',
  'Feature File Name (.mp4)',
  'Trailer File Name (.mp4)',
  'Lang 1',
  'Lang 2',
  'Lang 3',
  'Lang 4',
  'Lang 5',
  'Lang 6',
  'Sub Embed 1',
  'Sub Embed 2',
  'Sub Dynamic 1',
  'Sub Dynamic 2',
  'Closed Caps',
]

export const AUDIO_TRACK_NAMES = ['Lang 1', 'Lang 2', 'Lang 3', 'Lang 4', 'Lang 5', 'Lang 6']

export const TEXT_TRACK_NAMES = ['Sub Embed 1', 'Sub Embed 2', 'Sub Dynamic 1', 'Sub Dynamic 2', 'Closed Caps']

export const matchesFieldName = (names, name) => names.some((entry) => entry.toLowerCase() === name?.toLowerCase())

export const fieldOrderIn = (names, name) => {
  const index = names.findIndex((entry) => entry.toLowerCase() === name?.toLowerCase())
  return index === -1 ? names.length : index
}
